var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeedInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3468_49985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3468_49985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error",
    d: "M15.997 22.6665C16.3306 22.6665 16.6104 22.5537 16.8363 22.328C17.0622 22.1023 17.1752 21.8227 17.1752 21.4891C17.1752 21.1555 17.0623 20.8758 16.8367 20.6498C16.611 20.4239 16.3314 20.311 15.9978 20.311C15.6642 20.311 15.3844 20.4238 15.1585 20.6495C14.9326 20.8751 14.8196 21.1547 14.8196 21.4883C14.8196 21.8219 14.9325 22.1017 15.1581 22.3276C15.3838 22.5535 15.6634 22.6665 15.997 22.6665ZM14.953 17.4887H17.1752V9.19984H14.953V17.4887ZM16.0033 29.3332C14.1628 29.3332 12.4332 28.9832 10.8144 28.2832C9.19567 27.5832 7.78259 26.6295 6.57516 25.4221C5.36776 24.2146 4.41406 22.801 3.71406 21.1812C3.01406 19.5613 2.66406 17.8305 2.66406 15.9887C2.66406 14.147 3.01406 12.4161 3.71406 10.7963C4.41406 9.17644 5.36776 7.7665 6.57516 6.5665C7.78259 5.3665 9.19622 4.4165 10.8161 3.7165C12.4359 3.0165 14.1667 2.6665 16.0085 2.6665C17.8503 2.6665 19.5811 3.0165 21.2009 3.7165C22.8208 4.4165 24.2307 5.3665 25.4307 6.5665C26.6307 7.7665 27.5807 9.17762 28.2807 10.7998C28.9807 12.4221 29.3307 14.1534 29.3307 15.9939C29.3307 17.8344 28.9807 19.564 28.2807 21.1828C27.5807 22.8016 26.6307 24.2133 25.4307 25.418C24.2307 26.6226 22.8196 27.5763 21.1974 28.2791C19.5752 28.9818 17.8438 29.3332 16.0033 29.3332ZM16.0085 27.111C19.0974 27.111 21.7196 26.0295 23.8752 23.8665C26.0308 21.7036 27.1085 19.0776 27.1085 15.9887C27.1085 12.8998 26.0321 10.2776 23.8794 8.12204C21.7266 5.96648 19.0992 4.8887 15.9974 4.8887C12.9159 4.8887 10.2937 5.96509 8.13073 8.11787C5.96775 10.2707 4.88626 12.898 4.88626 15.9998C4.88626 19.0813 5.96775 21.7036 8.13073 23.8665C10.2937 26.0295 12.9196 27.111 16.0085 27.111Z",
    fill: "#054BC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedInfoBlue);
export default __webpack_public_path__ + "static/media/need_info_blue.a4ba2988f8890ae4d3eeda3fae988fb5.svg";
export { ForwardRef as ReactComponent };